export var AblyResponseTypes;

(function (AblyResponseTypes) {
  AblyResponseTypes["NOTIFICATION_TYPE_CHAT_MESSAGE_ADDED"] = "NOTIFICATION_TYPE_CHAT_MESSAGE_ADDED";
  AblyResponseTypes["NOTIFICATION_TYPE_CHAT_INTENT_ADDED"] = "NOTIFICATION_TYPE_CHAT_INTENT_ADDED";
  AblyResponseTypes["NOTIFICATION_TYPE_COMMENT_ADDED"] = "NOTIFICATION_TYPE_COMMENT_ADDED";
  AblyResponseTypes["NOTIFICATION_TYPE_TASK_CREATED_BY_REP"] = "NOTIFICATION_TYPE_TASK_CREATED_BY_REP";
  AblyResponseTypes["NOTIFICATION_TYPE_TASK_CHANGED_V2"] = "NOTIFICATION_TYPE_TASK_CHANGED_V2";
  AblyResponseTypes["NOTIFICATION_TYPE_TASK_AWAITING_FEEDBACK"] = "NOTIFICATION_TYPE_TASK_AWAITING_FEEDBACK";
  AblyResponseTypes["NOTIFICATION_TYPE_TASK_INDICES_CHANGED"] = "NOTIFICATION_TYPE_TASK_INDICES_CHANGED";
  AblyResponseTypes["NOTIFICATION_TYPE_TASK_TITLE_CHANGED"] = "NOTIFICATION_TYPE_TASK_TITLE_CHANGED";
  AblyResponseTypes["NOTIFICATION_TYPE_TASK_PROPOSAL_READY_TO_REVIEW"] = "NOTIFICATION_TYPE_TASK_PROPOSAL_READY_TO_REVIEW";
  AblyResponseTypes["NOTIFICATION_TYPE_TASK_PROPOSAL_ELECTED"] = "NOTIFICATION_TYPE_TASK_PROPOSAL_ELECTED";
  AblyResponseTypes["NOTIFICATION_TYPE_ENTITLEMENT_CHANGED"] = "NOTIFICATION_TYPE_ENTITLEMENT_CHANGED";
  AblyResponseTypes["NOTIFICATION_TYPE_CHAT_PARTICIPANTS_ADDED"] = "NOTIFICATION_TYPE_CHAT_PARTICIPANTS_ADDED";
  AblyResponseTypes["NOTIFICATION_TYPE_CHAT_PARTICIPANTS_CHANGED"] = "NOTIFICATION_TYPE_CHAT_PARTICIPANTS_CHANGED";
  AblyResponseTypes["NOTIFICATION_TYPE_TASK_UPDATED_TO_INPROGRESS_BY_REP"] = "NOTIFICATION_TYPE_TASK_UPDATED_TO_INPROGRESS_BY_REP";
  AblyResponseTypes["NOTIFICATION_TYPE_GUIDE_INTERACTION_UPDATE"] = "NOTIFICATION_TYPE_GUIDE_INTERACTION_UPDATE";
})(AblyResponseTypes || (AblyResponseTypes = {}));

export var AblyIntentAddedTypes;

(function (AblyIntentAddedTypes) {
  AblyIntentAddedTypes["MESSAGE_INTENT_TYPE_DELETE"] = "MESSAGE_INTENT_TYPE_DELETE";
})(AblyIntentAddedTypes || (AblyIntentAddedTypes = {}));

export var TaskSectionTypes;

(function (TaskSectionTypes) {
  TaskSectionTypes["messages"] = "messages";
  TaskSectionTypes["option"] = "option";
})(TaskSectionTypes || (TaskSectionTypes = {}));

export var TaskTab;

(function (TaskTab) {
  TaskTab["MY_LIST"] = "my-list";
  TaskTab["UPCOMING"] = "upcoming";
  TaskTab["IN_PROGRESS"] = "in-progress";
  TaskTab["COMPLETED"] = "completed";
})(TaskTab || (TaskTab = {}));

export var AccessType;

(function (AccessType) {
  AccessType[AccessType["PREVIEW"] = 0] = "PREVIEW";
  AccessType[AccessType["LIMITED"] = 1] = "LIMITED";
  AccessType[AccessType["FULL"] = 2] = "FULL";
  AccessType[AccessType["CANCELED"] = 3] = "CANCELED";
  AccessType[AccessType["PAUSED"] = 4] = "PAUSED";
})(AccessType || (AccessType = {}));

export var ChatMessageStatus; // The type for the member charge.

(function (ChatMessageStatus) {
  ChatMessageStatus["SENDING"] = "SENDING";
  ChatMessageStatus["SENT"] = "SENT";
  ChatMessageStatus["ERROR"] = "ERROR";
  ChatMessageStatus["RETRYING"] = "RETRYING";
})(ChatMessageStatus || (ChatMessageStatus = {}));

export var ChargeType; // The type of end membership request

(function (ChargeType) {
  ChargeType[ChargeType["CHARGE_TYPE_UNSPECIFIED"] = 0] = "CHARGE_TYPE_UNSPECIFIED";
  ChargeType[ChargeType["CHARGE_TYPE_THIRD_PARTY_PURCHASE"] = 1] = "CHARGE_TYPE_THIRD_PARTY_PURCHASE";
  ChargeType[ChargeType["CHARGE_TYPE_CONTRACTED_PRO_PAYMENT"] = 2] = "CHARGE_TYPE_CONTRACTED_PRO_PAYMENT";
})(ChargeType || (ChargeType = {}));

export var EndIntentCase;

(function (EndIntentCase) {
  EndIntentCase[EndIntentCase["END_INTENT_NOT_SET"] = 0] = "END_INTENT_NOT_SET";
  EndIntentCase[EndIntentCase["CANCEL"] = 1] = "CANCEL";
  EndIntentCase[EndIntentCase["PAUSE_INDEFINITELY"] = 2] = "PAUSE_INDEFINITELY";
})(EndIntentCase || (EndIntentCase = {}));

export var TodoEditType;

(function (TodoEditType) {
  TodoEditType[TodoEditType["TODO_MAKE_RECURRING"] = 0] = "TODO_MAKE_RECURRING";
  TodoEditType[TodoEditType["TODO_EDIT_RECURRING_QUESTION"] = 1] = "TODO_EDIT_RECURRING_QUESTION";
})(TodoEditType || (TodoEditType = {}));